const dateTime = {
  'dateTime.lastMonthsPlusCurrent':
    'Last <%=months > 1 ? months : "" %> Month<%=months > 1 ? "s" : "" %> + Current Month',
  'dateTime.date': 'Date',
  'dateTime.day': 'day',
  'dateTime.year': 'Year',
  'dateTime.invalidRange': 'Start date cannot be after the end date.',
  'dateTime.invalidDate': 'Invalid date selected.'
};

export default dateTime;

export const calendarMonths = {
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  may: 'May',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Oct',
  nov: 'Nov',
  dec: 'Dec'
};
